const t=(t="",e={})=>{const[n="",r=""]=t.split("?"),a=new URLSearchParams(r);Object.entries(e).forEach(([t,e])=>{a.append(t,e)});const s=a.toString();return s?`${n}?${s}`:n};export{t as default};
